import { z } from 'zod';

import type { AssociatedType } from '@/models/AssociatedType.ts';

export const NotificationCallStatusSchema = z.enum([
  'PENDING',
  'ACTIVE',
  'COMPLETE',
  'TERMINATED',
]);
export type NotificationCallStatus = z.infer<
  typeof NotificationCallStatusSchema
>;

export const NotificationCallSchema = z.object({
  id: z.string(),
  frequency: z.string().nullable(),
  callId: z.string().nullable(),
  bindId: z.string().nullable(),
  bindType: z.custom<AssociatedType>(),
  bindName: z.string().nullable(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  description: z.string().nullable(),
  status: NotificationCallStatusSchema.nullable().optional(),
  completeTime: z.string().nullable(),
  completeUserId: z.string().nullable().optional(),
  completeUserName: z.string().nullable().optional(),
  createUserId: z.string().nullable().optional(),
  createUserName: z.string().nullable().optional(),
  createDate: z.string(),
  lastUpdateDate: z.string(),
  createReasonId: z.string().nullable().optional(),
});
export type NotificationCall = z.infer<typeof NotificationCallSchema>;
